import { useCurrentUser } from '@oriola-corporation/ecom-portal-auth';
import React, { createContext, useContext } from 'react';

interface Pharmacy {
  id: string;
}

export const pharmacyContext = createContext(null);

export const useProvidePharmacy = (): { id: string | null } => {
  const currentUser = useCurrentUser();
  const { pharmacyId } = currentUser;
  return {
    id: pharmacyId,
  };
};

export const PharmacyProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const pharmacy = useProvidePharmacy();

  if (!pharmacy) {
    throw new Error('No pharmacy id found');
  }
  // @ts-expect-error I dont want to fix this
  return <pharmacyContext.Provider value={pharmacy}>{children}</pharmacyContext.Provider>;
};

export const usePharmacy = () => {
  // @ts-expect-error I dont want to fix this
  return useContext<Pharmacy>(pharmacyContext);
};
